//ROLEX CUSTOM VARS TAGGING AND TRACKING START 
//ADD NEW CONDITIONS FOR BLOGS BASED ON EXISTING
//ROLEX YEAR 2025 CHANGE FROM 2024

document.addEventListener("DOMContentLoaded", function() {

    if (window.location.pathname === '/pages/rolex-discover') {
        window.digitalDataLayer = {
        environment: {
            environmentVersion: "V7",
            coBrandedVersion: "Bespoke",
        },
        page: {
            pageType: "home page"
        }
    };
    }

    else if (window.location.pathname.startsWith('/products/rolex-')) {
        // Extract the dynamic parts from the URL
        var currentPath = window.location.pathname.replace('/products/rolex-', '');

    	var familyName, serialNumber;


        var matchWithNumber = currentPath.match(/(.+)-\d{2}-(m.+)/);

        if (matchWithNumber) {
            familyName = matchWithNumber[1]; // Extract family name
            serialNumber = matchWithNumber[2]; // Extract serial number
        	}
    	  else { 
        	var matchWithoutNumber = currentPath.match(/(.+)-(m.+)/);
        	if (matchWithoutNumber) {
                familyName = matchWithoutNumber[1]; // Extract family name
                serialNumber = matchWithoutNumber[2]; // Extract serial number
            	}
            }

        if (familyName) {
              
            familyName = familyName
              .replace(/submariner-date$/, 'submariner')    
              .replace(/deepsea-challenge$/, 'deepsea') 
              .replace(/explorer-ii$/, 'explorer');        
          }

        if (familyName && serialNumber){
              // Push to the digitalDataLayer
             window.digitalDataLayer = {
              environment: {
                environmentVersion: "V7",
                coBrandedVersion: "Bespoke",
              },
              page: {
                pageType: "model page",
                pageFamilyName: familyName,
              },
              products: {
                productRMC: serialNumber
              }
            }
          console.log("Tagging works fine.");
        }
      else {
          console.log("URL match does not work");
      }
    }

    else if (window.location.pathname === '/pages/rolex-contact-ottawa') {
        window.digitalDataLayer = {
          environment: {
            environmentVersion: "V7",
            coBrandedVersion: "Bespoke",
          },
          page: {
            pageType: "store contact page"
          }
        }
    }
      else if (window.location.pathname === '/pages/rolex-new-watches') {
        window.digitalDataLayer = {
          environment: {
            environmentVersion: "V7",
            coBrandedVersion: "Bespoke",
          },
          page: {
            pageType: "new watches page"
          }
        }
    }
      else if (window.location.pathname === '/pages/rolex-festive-selection') {
        window.digitalDataLayer = {
          environment: {
            environmentVersion: "V7",
            coBrandedVersion: "Bespoke",
          },
          page: {
            pageType: "festive page"
          }
        }
    } 
      else if (window.location.pathname === '/pages/rolex-watchmaking') {
        window.digitalDataLayer = {
          environment: {
            environmentVersion: "V7",
            coBrandedVersion: "Bespoke",
          },
          page: {
            pageType: "watchmaking page"
          }
        }
    }
      else if (window.location.pathname === '/pages/rolex-watches') {
        window.digitalDataLayer = {
          environment: {
            environmentVersion: "V7",
            coBrandedVersion: "Bespoke",
          },
          page: {
            pageType: "collection page"
          }
        }
    }
      else if (window.location.pathname === '/pages/rolex-new-watches-gmt-master-ii') {
        window.digitalDataLayer = {
          environment: {
            environmentVersion: "V7",
            coBrandedVersion: "Bespoke",
          },
          page: {
            pageType: "family page 2025",
            pageFamilyName: "gmt-master-ii"
          }
        }
    }
      else if (window.location.pathname === '/pages/rolex-new-watches-land-dweller') {
        window.digitalDataLayer = {
          environment: {
            environmentVersion: "V7",
            coBrandedVersion: "Bespoke",
          },
          page: {
            pageType: "family page 2025",
            pageFamilyName: "land-dweller"
          }
        }
    }
      else if (window.location.pathname === '/pages/rolex-new-watches-oyster-perpetual') {
        window.digitalDataLayer = {
          environment: {
            environmentVersion: "V7",
            coBrandedVersion: "Bespoke",
          },
          page: {
            pageType: "family page 2025",
            pageFamilyName: "oyster-perpetual"
          }
        }
    }
      else if (window.location.pathname === '/pages/rolex-new-watches-1908') {
        window.digitalDataLayer = {
          environment: {
            environmentVersion: "V7",
            coBrandedVersion: "Bespoke",
          },
          page: {
            pageType: "family page 2025",
            pageFamilyName: "1908"
          }
        }
    }
      else if (window.location.pathname === '/pages/rolex-new-watches-datejust') {
        window.digitalDataLayer = {
          environment: {
            environmentVersion: "V7",
            coBrandedVersion: "Bespoke",
          },
          page: {
            pageType: "family page 2025",
            pageFamilyName: "datejust"
          }
        }
    }
      else if (window.location.pathname === '/pages/rolex-new-watches-exclusive-dials') {
        window.digitalDataLayer = {
          environment: {
            environmentVersion: "V7",
            coBrandedVersion: "Bespoke",
          },
          page: {
            pageType: "family page 2025"
          }
        }
    }
      else if (window.location.pathname === '/collections/rolex-accessories') {
        window.digitalDataLayer = {
          environment: {
            environmentVersion: "V7",
            coBrandedVersion: "Bespoke",
          },
          page: {
            pageType: "accessories page"
          }
        }
    }
      else if (window.location.pathname === '/collections/rolex-day-date') {
        window.digitalDataLayer = {
          environment: {
            environmentVersion: "V7",
            coBrandedVersion: "Bespoke",
          },
          page: {
            pageType: "family page",
            pageFamilyName: "day-date"
          }
        }
    }
      else if (window.location.pathname === '/collections/rolex-land-dweller') {
        window.digitalDataLayer = {
          environment: {
            environmentVersion: "V7",
            coBrandedVersion: "Bespoke",
          },
          page: {
            pageType: "family page",
            pageFamilyName: "land-dweller"
          }
        }
    }
      else if (window.location.pathname === '/collections/rolex-datejust') {
        window.digitalDataLayer = {
          environment: {
            environmentVersion: "V7",
            coBrandedVersion: "Bespoke",
          },
          page: {
            pageType: "family page",
            pageFamilyName: "datejust"
          }
        }
    }
      else if (window.location.pathname === '/collections/rolex-lady-datejust') {
        window.digitalDataLayer = {
          environment: {
            environmentVersion: "V7",
            coBrandedVersion: "Bespoke",
          },
          page: {
            pageType: "family page",
            pageFamilyName: "lady-datejust"
          }
        }
    }
      else if (window.location.pathname === '/collections/rolex-sky-dweller') {
        window.digitalDataLayer = {
          environment: {
            environmentVersion: "V7",
            coBrandedVersion: "Bespoke",
          },
          page: {
            pageType: "family page",
            pageFamilyName: "sky-dweller"
          }
        }
    }
      else if (window.location.pathname === '/collections/rolex-oyster-perpetual') {
        window.digitalDataLayer = {
          environment: {
            environmentVersion: "V7",
            coBrandedVersion: "Bespoke",
          },
          page: {
            pageType: "family page",
            pageFamilyName: "oyster-perpetual"
          }
        }
    }
      else if (window.location.pathname === '/collections/rolex-sea-dweller') {
        window.digitalDataLayer = {
          environment: {
            environmentVersion: "V7",
            coBrandedVersion: "Bespoke",
          },
          page: {
            pageType: "family page",
            pageFamilyName: "sea-dweller"
          }
        }
    }
      else if (window.location.pathname === '/collections/rolex-air-king') {
        window.digitalDataLayer = {
          environment: {
            environmentVersion: "V7",
            coBrandedVersion: "Bespoke",
          },
          page: {
            pageType: "family page",
            pageFamilyName: "air-king"
          }
        }
    }
      else if (window.location.pathname === '/collections/rolex-gmt-master-ii') {
        window.digitalDataLayer = {
          environment: {
            environmentVersion: "V7",
            coBrandedVersion: "Bespoke",
          },
          page: {
            pageType: "family page",
            pageFamilyName: "gmt-master-ii"
          }
        }
    }
      else if (window.location.pathname === '/collections/rolex-yacht-master') {
        window.digitalDataLayer = {
          environment: {
            environmentVersion: "V7",
            coBrandedVersion: "Bespoke",
          },
          page: {
            pageType: "family page",
            pageFamilyName: "yacht-master"
          }
        }
    }
      else if (window.location.pathname === '/collections/rolex-cosmograph-daytona') {
        window.digitalDataLayer = {
          environment: {
            environmentVersion: "V7",
            coBrandedVersion: "Bespoke",
          },
          page: {
            pageType: "family page",
            pageFamilyName: "cosmograph-daytona"
          }
        }
    }
      else if (window.location.pathname === '/collections/rolex-submariner') {
        window.digitalDataLayer = {
          environment: {
            environmentVersion: "V7",
            coBrandedVersion: "Bespoke",
          },
          page: {
            pageType: "family page",
            pageFamilyName: "submariner"
          }
        }
    }
      else if (window.location.pathname === '/collections/rolex-deepsea') {
        window.digitalDataLayer = {
          environment: {
            environmentVersion: "V7",
            coBrandedVersion: "Bespoke",
          },
          page: {
            pageType: "family page",
            pageFamilyName: "deepsea"
          }
        }
    }
      else if (window.location.pathname === '/collections/rolex-explorer') {
        window.digitalDataLayer = {
          environment: {
            environmentVersion: "V7",
            coBrandedVersion: "Bespoke",
          },
          page: {
            pageType: "family page",
            pageFamilyName: "explorer"
          }
        }
    }
      else if (window.location.pathname === '/collections/rolex-1908') {
        window.digitalDataLayer = {
          environment: {
            environmentVersion: "V7",
            coBrandedVersion: "Bespoke",
          },
          page: {
            pageType: "family page",
            pageFamilyName: "1908"
          }
        }
    }
      else if (window.location.pathname === '/pages/rolex-servicing') {
        window.digitalDataLayer = {
          environment: {
            environmentVersion: "V7",
            coBrandedVersion: "Bespoke",
          },
          page: {
            pageType: "servicing your rolex page"
          }
        }
    }
      else if (window.location.pathname === '/pages/rolex-servicing-procedure') {
        window.digitalDataLayer = {
          environment: {
            environmentVersion: "V7",
            coBrandedVersion: "Bespoke",
          },
          page: {
            pageType: "servicing procedure page"
          }
        }
    }
      else if (window.location.pathname === '/blogs/world-of-rolex') {
        window.digitalDataLayer = {
          environment: {
            environmentVersion: "V7",
            coBrandedVersion: "Bespoke",
          },
          page: {
            pageType: "article hub page"
          }
        }
    }
      else if (window.location.pathname === '/blogs/world-of-rolex/rolex-and-the-open-golfs-oldest-major') {
        window.digitalDataLayer = {
          environment: {
            environmentVersion: "V7",
            coBrandedVersion: "Bespoke",
          },
          page: {
            pageType: "article page"
          }
        }
    }
      else if (window.location.pathname === '/blogs/world-of-rolex/rolex-and-the-us-open-an-electric-atmosphere') {
        window.digitalDataLayer = {
          environment: {
            environmentVersion: "V7",
            coBrandedVersion: "Bespoke",
          },
          page: {
            pageType: "article page"
          }
        }
    }
      else if (window.location.pathname === '/blogs/world-of-rolex/rolex-and-the-amundi-evian-championship') {
        window.digitalDataLayer = {
          environment: {
            environmentVersion: "V7",
            coBrandedVersion: "Bespoke",
          },
          page: {
            pageType: "article page"
          }
        }
    }
      else if (window.location.pathname === '/blogs/world-of-rolex/rolex-and-the-championships-wimbledon') {
        window.digitalDataLayer = {
          environment: {
            environmentVersion: "V7",
            coBrandedVersion: "Bespoke",
          },
          page: {
            pageType: "article page"
          }
        }
    }
      else if (window.location.pathname === '/blogs/world-of-rolex/the-24-hours-of-le-mans') {
        window.digitalDataLayer = {
          environment: {
            environmentVersion: "V7",
            coBrandedVersion: "Bespoke",
          },
          page: {
            pageType: "article page"
          }
        }
    }
      else if (window.location.pathname === '/blogs/world-of-rolex/a-voyage-into-the-world-of-rolex') {
        window.digitalDataLayer = {
          environment: {
            environmentVersion: "V7",
            coBrandedVersion: "Bespoke",
          },
          page: {
            pageType: "article page"
          }
        }
    }
      else if (window.location.pathname === '/blogs/world-of-rolex/sailgp') {
        window.digitalDataLayer = {
          environment: {
            environmentVersion: "V7",
            coBrandedVersion: "Bespoke",
          },
          page: {
            pageType: "article page"
          }
        }
    }
      else if (window.location.pathname === '/blogs/world-of-rolex/rolex-grand-slam-of-show-jumping') {
        window.digitalDataLayer = {
          environment: {
            environmentVersion: "V7",
            coBrandedVersion: "Bespoke",
          },
          page: {
            pageType: "article page"
          }
        }
    }
      else if (window.location.pathname === '/blogs/world-of-rolex/rolex-and-the-vienna-philharmonic') {
        window.digitalDataLayer = {
          environment: {
            environmentVersion: "V7",
            coBrandedVersion: "Bespoke",
          },
          page: {
            pageType: "article page"
          }
        }
    }
        else if (window.location.pathname === '/blogs/world-of-rolex/endurance') {
        window.digitalDataLayer = {
          environment: {
            environmentVersion: "V7",
            coBrandedVersion: "Bespoke",
          },
          page: {
            pageType: "article page"
          }
        }
    }
      else if (window.location.pathname === '/pages/rolex-send-us-a-message') {
        window.digitalDataLayer = {
          environment: {
            environmentVersion: "V7",
            coBrandedVersion: "Bespoke",
          },
          page: {
            pageType: "contact form page"
          }
        }
    }
      else if (window.location.pathname === '/pages/rolex-howard-fine-jewellers') {
        window.digitalDataLayer = {
          environment: {
            environmentVersion: "V7",
            coBrandedVersion: "Bespoke",
          },
          page: {
            pageType: "rolex at page"
          }
        }
    }
      else if (window.location.pathname === '/pages/rolex-history') {
        window.digitalDataLayer = {
          environment: {
            environmentVersion: "V7",
            coBrandedVersion: "Bespoke",
          },
          page: {
            pageType: "history page"
          }
        }
    }
      else if (window.location.pathname === '/pages/rolex-team') {
        window.digitalDataLayer = {
          environment: {
            environmentVersion: "V7",
            coBrandedVersion: "Bespoke",
          },
          page: {
            pageType: "team page"
          }
        }
    }
      else if (window.location.pathname === '/pages/rolex-showroom') {
        window.digitalDataLayer = {
          environment: {
            environmentVersion: "V7",
            coBrandedVersion: "Bespoke",
          },
          page: {
            pageType: "showroom page"
          }
        }
    }

});

